export const financeGettingStartedArticle = {
  title: 'Finance Command Center: Getting Started',
  slug: 'finance-getting-started',
  content: `Finance Command Center: Getting Started

Track transactions, dashboards, and insights from the Finance Hub.

1) Open Finance Hub
- Go to /finance-hub.
- Tabs are controlled by URL hash (#transactions, #dashboard, #insights).

2) Log transactions
- Use the Transactions tab for revenue and expense entries.

3) Monitor dashboards
- Dashboard summarizes key financial metrics.

4) Review insights
- Insights highlight trends and anomalies.

Related tools
- Forecasting Hub: /forecasting-hub (break-even and cash flow).
- Pricing Hub: /pricing-hub (calculator, margins, strategy).
`,
};
